import { render, staticRenderFns } from "./AppointmentCheckDetail.vue?vue&type=template&id=6f4a8aff&scoped=true"
import script from "./AppointmentCheckDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentCheckDetail.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCheckDetail.vue?vue&type=style&index=0&id=6f4a8aff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a8aff",
  null
  
)

export default component.exports